import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {useNavigate} from "react-router";

/* Gets the current location, and navigates back one level in the URL
* Example Usage:
* If current Url is mysite.com/location/detail/:id...
*  const parentUrl = useBackwardNav();
*  navigate(parentUrl)
*  Navigates back one level to mysite.com/location/detail
*/
// export function useBackwardNav() {
// // export function useBackwardNav({backwardCount = 1}: {backwardCount?:number | null} = {}) {
//     const currentUrl = useLocation();
//     const navigate = useNavigate();
//     const parentUrl = useMemo(() => {
//         const urlSegments = currentUrl.pathname.split('/');
//         urlSegments.pop();
//         let joinedSegments = urlSegments.join('/');
//         if (joinedSegments === "") joinedSegments = "/";
//         return joinedSegments;
//     }, [currentUrl]);
//
//     const navigateBackward = (backwardNum = 1) => navigate(parentUrl);
//     return { parentUrl, navigateBackward }
// }

/**
 * Returns `parentUrl` (current pathname string) and a `navigateBackward`
 * function that slices off segments from the current URL path and navigates
 * back using react-router.
 */
export function useBackwardNav() {
    const currentUrl = useLocation();
    const navigate = useNavigate();
    const urlSegments = currentUrl.pathname.split('/');
    const numSegments = urlSegments.length;

    const navigateBackward = (backwardNum: number = 1) => {
        const validBackwardNum = Math.min(backwardNum, numSegments);
        const newSegments = urlSegments.slice(0, numSegments - validBackwardNum);
        const newUrl = newSegments.join('/') || '/';
        navigate(newUrl);
    };

    return { parentUrl: currentUrl.pathname, navigateBackward };
}
